<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Notifications" />
      <h2>Notifications</h2>
      <flash-messages />
    </template>
        
    <template v-slot:breadcrumbs>
      <BreadCrumbs activeItem="Notifications" :crumbs="{ home: 'Dashboard' }"/>
    </template>
        
    <template v-slot:default>
      <DataTable :value="notifications.data" :paginator="true"
        :lazy="true"
        :first="(notifications.current_page-1)*notifications.per_page"
        :rows="notifications.per_page"
        :totalRecords="notifications.total"
        @page="onPage($event)"
        @sort="onSort($event)"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
        currentPageReportTemplate="({first} - {last} of {totalRecords})"
        paginatorPosition="both" 
        :rowsPerPageOptions="['10', '20', '50', '100']" 
        sortField="date" :sortOrder="-1"
        stateStorage="local" stateKey="admin-notifications-index" dataKey="id" breakpoint="992px"
        class="p-datatable-sm admin-datatable">
          <template #paginatorstart>
            {{ notifications.total }} Notifications
          </template>
          <Column field="to" header="To" :sortable="true"></Column>
          <Column field="subject" to="subject" header="Subject" :sortable="true"></Column>
          <Column field="type_desc" header="Type" :sortable="true"></Column>
          <Column field="date_sent" header="Date" :sortable="true">
            <template #body="slotProps">
              {{ moment(slotProps.data.date_sent).format('M/D/YY h:mm A') }}
              {{ slotProps.data.is_error ? "ERROR" : "" }}
            </template>
          </Column>
          <Column field="text" class="hide-title-mobile" header="Text" :sortable="true"></Column>
      </DataTable>
    </template>
  </layout>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import FlashMessages from '@/Shared/FlashMessages'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import moment from 'moment'

export default {
  components: {
    Icon,
    SearchFilter,
    Layout,
    FlashMessages,
    BreadCrumbs
  },
  props: {
    notifications: {
      type: Object,
      default: {
        data: [],
        per_page: 50,
        current_page: 0,
        total: 0,
      }
    },
    filters: Object,
    query: String,
    status: Array,
    selectedStatus: Array
  },
  data() {
    return {
      searchText: this.query,
      searchStatus: this.selectedStatus
    }
  },
  created() {
    this.moment = moment
  },
  methods: {
    search() {
      this.$inertia.get(this.route('admin.orders'),{
        query: this.searchText,
        status: this.searchStatus
      });
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    statusFilter(e) {
      this.$inertia.get(this.route('admin.orders'), {
        query: this.searchText,
        status: this.searchStatus
      });
    },
    async onPage(event, params = {}) {
      const data = {
        page: event.page + 1, per_page: event.rows,
        ...params
      };
      return new Promise((resolve, reject) => {
        this.$inertia.reload({
          preserveState: true,
          preserveScroll: true,
          data,
          onSuccess: () => {
            resolve()
          },
          onError: () => {
            resolve()
          },
        });
      })
    },
    onSort(event) {
      this.onPage({page: this.notifications.current_page - 1, rows: this.notifications.per_page}, {sort_field: event.sortField, sort_order: event.sortOrder})
    },
  },
}
</script>
